import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminMediaSubmissionDetail from "@/pages/admin/AdminMediaSubmissionDetail";

export const Route = createFileRoute("/admin/media-submissions/$id")({
  head: () => pageHead("Admin \u2014 Media Submissions \u2014 Id \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminMediaSubmissionDetail,
});
